import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ModalDialog, Stack, Button, Typography, StepIndicator, LodgeAILogo } from "@financeable-com-au/financeable-ui";
import {
  closeLodgeAIModal,
  lodgeAIQueueSelector,
  lodgeAISessionSelector,
  lodgeAIErrorSelector,
  resetLodgeAI,
} from "@/store/slices/lodgeAISlice";
import { buildBrokerLoopDeepLink } from "@/utils/brokerLoopDeepLink";
import type { UserSlice, UserState } from "@/store/slices/types/userSlice";
// @ts-expect-error: ignoring as it is existing js file
import { userSelector } from "@/store/slices/userSlice";

const modalWidth = "480px";

const QueueModal = () => {
  const { firstName } = useSelector<UserSlice, UserState>(userSelector);
  const lodgeAIQueue = useSelector(lodgeAIQueueSelector);
  const { sessionId, jwt, lender, traceId } = useSelector(lodgeAISessionSelector) ?? {};
  const sessionError = useSelector(lodgeAIErrorSelector);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(closeLodgeAIModal());
  };

  // If LodgeAI queue has progressed, either in progress is false or position is 0 then show the automation modal.
  useEffect(() => {
    if ((!lodgeAIQueue?.inProgress || !lodgeAIQueue?.queuePosition) && !sessionError) {
      if (!sessionId || !jwt) return;
      const deepLinkParams = new URLSearchParams({
        sessionId,
        token: jwt,
        LENDER: lender ?? "",
      });
      if (traceId) {
        deepLinkParams.set("traceId", traceId);
      }
      const deepLink = buildBrokerLoopDeepLink(deepLinkParams);
      if (typeof window !== "undefined") {
        window.open(deepLink, "_blank");
      }
      dispatch(resetLodgeAI());
    }
  }, [lodgeAIQueue?.inProgress, lodgeAIQueue?.queuePosition]);

  return (
    <ModalDialog minWidth={modalWidth} maxWidth={modalWidth}>
      <Stack rowGap={5} alignItems="center">
        <Stack rowGap={2}>
          <Typography component="h2" id="modal-title" level="title-md" textAlign="center">
            Hi {firstName}, thank you for waiting
          </Typography>
          <Typography display="flex" alignItems="center" gap={1} textAlign="center">
            Your current position for the <LodgeAILogo width="65px" /> queue is
          </Typography>
        </Stack>
        <StepIndicator color="neutral" size="lg" variant="outlined">
          {lodgeAIQueue?.queuePosition ?? 0}
        </StepIndicator>
        <Button variant="secondary" fullWidth onClick={handleCloseModal}>
          Cancel
        </Button>
      </Stack>
    </ModalDialog>
  );
};

export { QueueModal };
